export default __webpack_public_path__ + "static/media/customized-sales-region-vegshelf-marketplace.6e8b6916.png";